//Sort of mimics a row in one of the input tables from the iPad app
import {useForm} from "react-hook-form";

const MultilineInputRow = ({label, placeholder, value, name, state, validationRules, onChange, ...rest}) => {
    const {register, handleSubmit, watch, formState: {errors}} = useForm({mode: 'onBlur'});

    if (state) {
        value = state[name];
    }

    return (
        <div className={'form-input-area__input-row'}>
            {label &&
                <h3>{label}</h3>
            }

            <textarea
                className={errors[name] ? 'error' : 'multiline-input'}
                {...register(name, validationRules)}
                name={name}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                {...rest}
            />
            {validationRules && validationRules.required && <span className={'required-input'}>*</span>}
        </div>
    );
};

export default MultilineInputRow;
